import { render } from "./MailSVG.vue?vue&type=template&id=07c7e301"
import script from "./MailSVG.vue?vue&type=script&lang=js"
export * from "./MailSVG.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__